import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { ImageSlot } from "@/components/ImageSlot";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const ServicesGrid = () => (
  <section data-testid="services-section" aria-labelledby="services-heading" className="section bg-white">
    <div className="container-site">
      <SectionHeading id="services" title="What We Do" accent="Do" sub="From a patch repair to a full extension, we handle the lot." />
      <ul className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3 xl:gap-8">
        {SERVICES.map((s, i) => (
          <Reveal as="li" key={s.id} delay={i * 60}>
            <Link
              to={s.to}
              data-testid={`service-card-${s.id}`}
              className="card group flex h-full flex-col overflow-hidden transition-[border-color] duration-200 hover:border-brand"
            >
              <ImageSlot label={s.slot.id} note={s.slot.note} ratio="4:3" alt={s.alt} imgClassName="transition-transform duration-300 ease-out group-hover:scale-[1.02]" />
              <div className="flex flex-1 flex-col p-6">
                <h3>{s.title}</h3>
                <p className="mt-2 text-base text-body">{s.line}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-[15px] font-semibold text-brand">
                  {s.title} in Molesey &amp; Kingston
                  <ArrowRight size={18} aria-hidden="true" className="transition-transform duration-200 ease-out group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
